var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 64 64",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1 6v48l31 4 31-4v-48l-31 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 58v-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 8v19l4-2 4 2v-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 16 19 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 26 19 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 36 19 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 46 19 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 36-19 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 46-19 2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBookIcon);
export default __webpack_public_path__ + "static/media/open-book-icon.e94e9016cd11d42627b07504ed7e5ee1.svg";
export { ForwardRef as ReactComponent };